import { useMutation } from '@tanstack/react-query'
import {
  tandaiMenanggapi,
  updateLeadPrimary,
  createLeadPrimary,
  createLeadComment,
  exportLeadTrackers
} from "./api"

// Update lead primary
export const useUpdateLeadPrimary = () => {
  return useMutation({
    mutationFn: ({ leadId, data }) => updateLeadPrimary(leadId, data),
  })
}

// Create new lead primary
export const useCreateLeadPrimary = () => {
  return useMutation({
    mutationFn: (data) => createLeadPrimary(data),
  })
}

// Create comment for lead primary
export const useCreateLeadComment = () => {
  return useMutation({
    mutationFn: ({ leadId, data }) => createLeadComment(leadId, data),
  })
}

// Legacy mutation (keeping for backward compatibility)
export const useTandaiMenanggapi = () => {
  return useMutation({
    queryKey: ['lead-listing-tandai-menanggapi'],
    mutationFn: (leadId) => tandaiMenanggapi(leadId),
  })
}

// Export lead trackers report
export const useExportLeadTrackers = () => {
  return useMutation({
    mutationFn: (params) => exportLeadTrackers(params),
  })
}
